<mat-card class="filter">
  <div class="sortview">
       <!-- View Emails -->
      <mat-slide-toggle color="primary" (change)="changeToggle($event)"> 
        {{title}}   
      </mat-slide-toggle>
  </div>

 

  <div class="selectact">      
    <button mat-flat-button color="primary" (click)="addEmailAction()">
      <mat-icon>add</mat-icon> Create Email
    </button>
  </div>
</mat-card>



<ng-container *ngIf="showEmail==true"> 

  <div class="email-container">      

      <mat-accordion>
        <mat-expansion-panel *ngFor="let data of All3CEmailList; let i = index "  [expanded]="true" >
          <mat-expansion-panel-header >
            <mat-panel-title> 
              
              <div class="email-header">
                <p>{{data.subject}}</p> 

                <div class="email-date" *ngIf="data.senmessage!='Opened'">
                  <!-- {{data.sentDate+'Z' | date:'MM/dd/yyyy'}}  {{data.senmessage}} -->

                    {{data.sentDate+'Z' | date:'MM/dd/yyyy'}}  
           
                    <span *ngIf="data.senmessage=='Failed'" class="failmessage"> {{data.senmessage}} </span>
                    <span *ngIf="data.senmessage=='Sent'" class="senmessage"> {{data.senmessage}} </span>
                    <span *ngIf="data.senmessage=='Opened'" class="openmessage"> {{data.senmessage}} </span>

                  <button mat-icon-button class="trash" matTooltip="delete" (click)="removeActivityEmail(data)">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              
                
                <div class="email-date" *ngIf="data.senmessage=='Opened'">
                  {{data.sentDate+'Z' | date:'MM/dd/yyyy'}}  
                  <span *ngIf="data.senmessage=='Opened'" class="openmessage"> {{data.senmessage}} - {{data.readCount}} </span>
                  <!-- <span *ngIf="data.senmessage=='Opened'" class="openmessage">  {{data.sentDate+'Z' | date:'MM/dd/yyyy'}}  {{data.senmessage}} ({{data.readCount}})</span> -->
                 <!-- {{data.sentDate+'Z' | date:'MM/dd/yyyy'}}  {{data.senmessage}} ({{data.readCount}})                 -->
                 <button mat-icon-button class="trash" matTooltip="delete" (click)="removeActivityEmail(data)">
                  <mat-icon>delete_outline</mat-icon>
                </button>
                </div>             
                
               
             </div> 
    
            </mat-panel-title>
    
          </mat-expansion-panel-header>
    
          <div class="email-details">
            To, {{data.toRecipients}}      
        </div>
        <div class="email-body">
          <div [innerHTML]="data.body"></div>
        </div>
        </mat-expansion-panel>
    
      </mat-accordion>

  </div>

 

</ng-container>

<ng-container *ngIf="showBroadCast==true"> 

<div class="emailList">
  <mat-accordion>
    <mat-expansion-panel *ngFor="let data of All3CBroadCastList; let i = index " [expanded]="true" >
      <mat-expansion-panel-header>
        <mat-panel-title> 
          
          <div class="email-header">
      
           <mat-icon *ngIf="data.broadCastingType==1">email</mat-icon>
           <mat-icon *ngIf="data.broadCastingType==0">textsms</mat-icon>           

          <span class="email-header-label" >
           {{data.subject}}
          </span>

          <div class="email-date" *ngIf="data.senmessage!='Opened'">
           {{data.sentDate+'Z' | date:'MM/dd/yyyy'}}  
           <!-- {{data.senmessage}} -->
           <span *ngIf="data.senmessage=='Failed'" class="failmessage"> {{data.senmessage}} </span>
           <span *ngIf="data.senmessage=='Sent'" class="senmessage"> {{data.senmessage}} </span>
           <span *ngIf="data.senmessage=='Opened'" class="openmessage"> {{data.senmessage}} </span>
           
           
           <button mat-icon-button class="trash" matTooltip="Resend" (click)="resentBroadcastMessage(data); $event.stopPropagation()">
             <mat-icon>cached</mat-icon>
           </button>
         </div>
         
         <div class="email-date" *ngIf="data.senmessage=='Opened'">
          {{data.sentDate+'Z' | date:'MM/dd/yyyy'}}  
          <span *ngIf="data.senmessage=='Opened'" class="openmessage"> {{data.senmessage}} - {{data.readCount}}</span>
            
          <button mat-icon-button class="trash" matTooltip="Resend" (click)="resentBroadcastMessage(data); $event.stopPropagation()">
            <mat-icon>cached</mat-icon>
          </button>
        </div>

       </div> 

        </mat-panel-title>

      </mat-expansion-panel-header>

      <div class="email-body" style="margin-top: 15px;">
        <div [innerHTML]="data.message">
        </div>             
      </div>
    </mat-expansion-panel>

  </mat-accordion>

</div>


</ng-container>
